import { render } from "./LoadMore.vue?vue&type=template&id=efe64894&scoped=true"
import script from "./LoadMore.vue?vue&type=script&lang=js"
export * from "./LoadMore.vue?vue&type=script&lang=js"

import "./LoadMore.vue?vue&type=style&index=0&id=efe64894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe64894"]])

export default __exports__